<template>
  <div>
    <div
      v-if="getAppLoaded"
      class="l-account container-fluid"
      :style="`background-image: url(${backgroundImage})`"
    >
      <div class="row">
        <div
          class="es-xs-12 es-lg-5 es-xl-4 u-padding-large-lg-up u-padding-xlarge-xl-up"
        >
          <router-view />
        </div>
      </div>
    </div>
    <div v-else>Loading</div>
  </div>
</template>

<script>
import auth from "../mixins/auth";
const backgroundImage = require("@/assets/images/signin-bg.jpg");
export default {
  mixins: [auth],
  data() {
    return {
      backgroundImage,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/layouts/account.scss";
</style>
